import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Button } from '@mui/material';
import styled from '@emotion/styled';
import { FlexBoxColumn } from 'styles/layout';
import api from 'api';
import { useFeedback } from 'shared/hooks';

const ResourceWrapper = styled(FlexBoxColumn)`
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
`;
const LinkButton = styled(Button)`
  /* make it look like MUI <Link> */
  padding: 0;
  min-width: 0;
  text-transform: none;
  font-weight: 500;
  font-size: inherit;
  font-family: inherit;
  color: ${({ theme }) => theme.palette.primary.main};
  background: none;
  text-decoration: underline;
  cursor: pointer;
  box-shadow: none;

  &:hover {
    text-decoration: none;
    background: transparent;
  }

  &:disabled {
    color: ${({ theme }) => theme.palette.action.disabled};
    text-decoration: none;
    cursor: not-allowed;
  }
`;

const ResourceItem = ({ item }) => {
  const { errorDisplay } = useFeedback();
  const handleClick = async (e) => {
    e.preventDefault();
    try {
      const response = await api.logUserSupportResource(item.id);
      if (response?.status === 200) {
        window.open(item.link, '_blank', 'noopener,noreferrer');
      }
    } catch (_error) {
      errorDisplay('Failed to open the resource. Please try again later.');
    };
  };
  return (
    <ResourceWrapper>
      <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
        <LinkButton onClick={handleClick} disableRipple>
          {item.title}
        </LinkButton>
      </Typography>
      {item.description && (
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {item.description}
        </Typography>
      )}
    </ResourceWrapper>
  );
};

ResourceItem.propTypes = {
  item: PropTypes.shape({
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    description: PropTypes.string,
  }).isRequired,
};

export default ResourceItem;
